import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-076f081c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "table-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_connection_success = _resolveComponent("connection-success");
  return $data.showAuthStatus ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_connection_success)])) : _createCommentVNode("", true);
}